<template>
  <div id="consulting-beneficiary">
    <v-container grid-list-xl>
      <v-layout align-center row wrap>
        <v-flex xs6>
          <div class="subheading">Consulting Beneficiary</div>
        </v-flex>
        <v-flex text-xs-right xs6>
          <ConsultingBeneficiaryDialog />
        </v-flex>
        <v-flex xs12>
          <!-- Data Table -->
          <v-data-table
            :headers="headers"
            :items="states"
            :loading="tableLoading"
            class="elevation-0"
            disable-initial-sort
            hide-actions
          >
            <template slot="items" slot-scope="props">
              <tr @click="editItem(props.item.idx)">
                <!-- <td>{{ props.item.idx }}</td> -->
                <!-- <td>{{ props.item.consultingTopicName || '-' }}</td> -->
                <td>{{ props.item.name || '-' }}</td>
                <td>{{ props.item.link || '-' }}</td>
                <td>
                  <v-icon color="green" v-if="props.item.description">done</v-icon>
                  <div v-else>-</div>
                </td>
                <td>{{ props.item.orders || '-' }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import ConsultingBeneficiaryDialog from '@/components/admin/ConsultingBeneficiaryDialog'
export default {
  name: 'consulting-beneficiary',
  components: {
    ConsultingBeneficiaryDialog
  },
  data() {
    return {
      // Table
      tableLoading: false,
      headers: [
        // { text: 'ID', align: 'left', value: 'idx', width: '10' },
        // { text: 'Topic', align: 'left', value: 'consultingTopicName', width: '200' },
        { text: 'Name', align: 'left', value: 'name', width: '200' },
        { text: 'Link', align: 'left', value: '', width: '200' },
        {
          text: 'Desc',
          align: 'left',
          value: 'description',
          width: '10'
        },
        { text: 'Orders', align: 'left', value: 'orders', width: '10' }
      ]
    }
  },
  computed: {
    states() {
      return this.$store.getters['ConsultingBeneficiary/getAll'].filter(
        item => item.consultingTopicId == this.$store.state.ConsultingTopic.idx
      )
    }
  },
  async created() {
    this.tableLoading = !this.tableLoading
    await this.$store.dispatch('ConsultingBeneficiary/fetch')
    this.tableLoading = !this.tableLoading
    this.$store.dispatch('ConsultingTopic/fetch')
  },
  methods: {
    editItem(idx) {
      this.$store.commit('ConsultingBeneficiary/UPDATE_DIALOG', true)
      this.$store.commit('ConsultingBeneficiary/SET_IDX', idx)
    }
  }
}
</script>

<style lang="scss" scoped></style>
